import * as React from 'react'
import { useState, useEffect } from 'react'
import { createApi } from '@core/fetch'

interface IProps {
  id: string;             // poster ID
  propertyName: string;   // poster 样式属性名
  api?: string;           // 获取poster请求接口（非必填）
  style?: any;            // 自定义样式
}

export default ({ id, propertyName, api, style }: IProps) => {
  const [banners, setbanners] = useState([]);
  const url: string = api
    || '/p/wedding/index.php/home/APIPosterBlock/block_info'

  useEffect(() => {
    createApi.get(url)({ id }).then(({ data, success }) => {
      if (success) {
        const params = data?.floors[propertyName]
        const banners = params?.holes?.map(({ posters }) => ({
          src: posters?.image_path,
          target: posters?.target_url,
        }))
        setbanners(banners)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, propertyName, api])
  return (
    banners.length > 0 ?
    <div style={style}>
      {
        banners.map(({ src, target }) => (
          <a target="_blank" rel="noopener noreferrer" href={target}>
            <img src={src} width="100%" />
          </a>
        ))
      }
    </div>
    : ''
  )
}
